export default __webpack_public_path__ + "static/media/website-video.0d1cf74d.mp4";